<form action="#">
    <h3 class="notification-cta" style="font-weight: 500;">Get notification of new properties</h3>
    <div class="form-field">
        <input type="email" [formControl]="email" placeholder="Enter email address">
        <button [disabled]="email.invalid" (click)="subscribe()" class="form-button">Subscribe</button>
    </div>
</form>
